const isClientCredentialsTokenValid = (accessToken) => !(accessToken === null || accessToken === undefined)

export default isClientCredentialsTokenValid
